import {
  ReadingIntentionsKey,
  normalisedReadingIntentionStatus,
} from '®shared/annotations';
import { AnalyticsEvent } from '®shared/events/analytics-event';
import { LaunchMethod } from '®shared/events/launch-method.constant';
import { LaunchMode } from '®shared/events/launch-mode.constant';

import {
  DestinationType,
  LinkPositionOnPage,
  OnlineResourceClickEvent,
} from './external-link-events';
import { ListItemClickAction } from './list-item-click-action';

export interface ListItemClickActionTypeAndSubtype {
  actionType: ListItemClickAction;
  actionSubtype?: string;
}

export interface ListItemClickEventProps {
  action_type: string;
  action_subtype?: string;
  item_id: string;
  launch_method: string;
  list_id: string;
  mode: string;
}

export interface ListItemClickAnalyticsEvent extends AnalyticsEvent {
  className: 'list.item.click';
  props: ListItemClickEventProps;
}

export function createListItemClickEvent(
  listId: string,
  itemId: string,
  action: ListItemClickActionTypeAndSubtype,
  launchMethod: LaunchMethod,
  mode: LaunchMode,
): ListItemClickAnalyticsEvent {
  const { actionType, actionSubtype } = action;
  return {
    className: 'list.item.click',
    props: {
      action_type: actionType,
      ...(actionSubtype && { action_subtype: actionSubtype }),
      item_id: itemId,
      launch_method: launchMethod,
      list_id: listId,
      mode,
    },
  };
}

export function listItemClickActionForOnlineResourceClick(
  event: OnlineResourceClickEvent,
): ListItemClickActionTypeAndSubtype {
  const { destination_type, position_on_page } = event;

  if (position_on_page === LinkPositionOnPage.VIEW_ONLINE_BUTTON) {
    if (destination_type === DestinationType.PREVIEW) {
      return listItemClickAction(
        ListItemClickAction.EXTERNAL_LINK,
        DestinationType.PREVIEW,
      );
    }
    return listItemClickAction(
      ListItemClickAction.EXTERNAL_LINK,
      LinkPositionOnPage.VIEW_ONLINE_BUTTON,
    );
  }

  return listItemClickAction(
    ListItemClickAction.EXTERNAL_LINK,
    destination_type,
  );
}

export function listItemClickActionForReadingIntention(
  status: ReadingIntentionsKey | null,
): ListItemClickActionTypeAndSubtype {
  return listItemClickAction(
    ListItemClickAction.READING_INTENTION,
    normalisedReadingIntentionStatus(status || ReadingIntentionsKey.Undecided),
  );
}

export function listItemClickAction(
  actionType: ListItemClickAction,
  actionSubtype?: string,
): ListItemClickActionTypeAndSubtype {
  return { actionType, ...(actionSubtype && { actionSubtype }) };
}

export function listItemClickActionForToggle(
  actionSubtype: 'expand' | 'collapse',
): ListItemClickActionTypeAndSubtype {
  return listItemClickAction(ListItemClickAction.TOGGLE_DETAIL, actionSubtype);
}
